export default __webpack_public_path__ + "static/board1-4cfb173ec6df29fc4450839b865d1d7d.jpg";